import { CompilationPreview } from "@turtlewave/types";

import { formatLastUpdated } from "../../utils/date";

interface CompilationDetailLayoutProps {
  compilation: CompilationPreview;
  preview?: boolean;
  children?: React.ReactNode;
}

export function CompilationDetailLayout({
  compilation,
  preview,
  children,
}: CompilationDetailLayoutProps) {
  return (
    <>
      <div
        className={`flex flex-col items-center ${preview ? "lg:mt-30" : "lg:mt-15"} mb-22`}
      >
        <h1 className="text-dark text-center font-serif text-3xl font-normal sm:text-5xl md:text-6xl">
          {compilation.title}
        </h1>

        <div className="sm:text-md mt-2 text-center text-sm text-neutral-700 md:mt-4 xl:text-lg">
          <span>{formatLastUpdated(compilation.last_edited_timestamp)}</span>
        </div>

        {compilation.description && (
          <p className="text-md text-dark mt-8 w-6/7 text-center text-pretty whitespace-pre-wrap sm:text-lg md:w-5/7 xl:text-xl">
            {compilation.description}
          </p>
        )}
      </div>

      {!preview && children}
    </>
  );
}
